module.exports = {
  disableTournamentCasinoPortrait: false,
  skin: "gamedaddy", // SKINS ====> ['gamedaddy', 'betpassion'],
  maskNickname: true,
  showLastBetToaster: false,
  hasYoutubeLinkOnHowToPlayPage: true,
  tournamentsHistoryPageItemsLimit: 1000,
  hasTextOnTournamentHistoryWidgetBanner: false,
  mulicurrency: {
    autoConvertToPlayerCurrency: false,
    enableCurrencySwitcherMenu: false,
  },
  showNetworkErrorToaster: false,
  withOutForceFullScreen: false,
  hasBigLeaderboard: false,
  enableJackpot: true,
  naviagtion: {
    jackpot: {
      show: true,
      disabled: true,
    },
    cashGames: {
      show: true,
      disabled: true,
    },
    WOS: {
      show: true,
      disabled: true,
    },
  },
  externalLinkHowGetTickets:
    "https://papigames.com/promotions?promo=GOTI-222k-D",
  mobileExternalLinkHowGetTickets:
    "https://papigames.com/promotions?promo=GOTI-222k-M",
  hasSkinSwitcher: true,
};
